import { useMediaQuery } from '@mui/material'

import { BaseModal2 } from '@components/modals/BaseModal2'
import { Breadcrumb } from '@components/shared/Breadcrumb'
import { emotionTheme } from '@styles/theme'
import { Title } from '@components/shared/Title'

import { WeekRelationSection } from './Section'

import type { WeekStatusRelationModalProps } from './types'

const SECTION_CARD_TITLE: Record<string, string> = {
  not_started: 'CLs não iniciadas',
  in_progress: 'CLs em Andamento',
  pending_approval: 'CLs em Validação',
  completed: 'CLs Finalizadas',
  auto_send: 'CLs em Envio Automático'
}

export const WeekStatusRelationModal = ({ open, onClose, data }: WeekStatusRelationModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  return (
    <BaseModal2
      open={open}
      onClose={onClose}
      width={isMobile ? 'calc(100% - 20px)' : '96.5%'}
      heightContainer="auto"
      maxHeightContainer={isMobile ? 'calc(100% - 20px)' : '95%'}
      headerIcon={
        <Breadcrumb
          breadcrumbData={[{ label: 'Gestão Financeira' }, { label: 'Prévia' }, { label: 'Gestão da Prévia' }]}
        />
      }
    >
      <Title label={`Relação das CLs da Semana ${data?.weekNumber ?? ''} (Status)`} marginTop={0} />

      {data?.sections.map((section) => (
        <WeekRelationSection
          key={section.code}
          section={section}
          cardTitle={SECTION_CARD_TITLE[section.code] ?? section.label}
        />
      ))}
    </BaseModal2>
  )
}
